import { equals, pickAll } from 'ramda';

import { BgOptions } from '../types/Branding.types';
import { IBranding, IBrandingParams, BrandingFields } from '../../../types/Branding.types';

export const getInitialBackgroundOption = ({
  backgroundImageUrl,
  backgroundColor,
  tertiaryColor,
}: {
  backgroundImageUrl: string | null;
  backgroundColor: string;
  tertiaryColor: string;
}): BgOptions => {
  if (backgroundImageUrl) {
    return BgOptions.bgImage;
  }
  return backgroundColor === tertiaryColor ? BgOptions.noPattern : BgOptions.alycePattern;
};

const comparingProps = [
  BrandingFields.backgroundColor,
  BrandingFields.tertiaryColor,
  BrandingFields.primaryColor,
  BrandingFields.secondaryColor,
  BrandingFields.highlightColor,
  BrandingFields.headlineColor,
  BrandingFields.primaryCtaColor,
  BrandingFields.secondaryCtaColor,
  BrandingFields.messageHeader,
  BrandingFields.logoUrl,
  BrandingFields.backgroundImageUrl,
  BrandingFields.termsUrl,
  BrandingFields.privacyPolicyLink,
  BrandingFields.contactSupportLink,
  BrandingFields.disclaimer,
  BrandingFields.giftCardConfirmationMessaging,
  BrandingFields.companyName,
];

export const compareBranding = (initialBranding?: IBranding, branding?: IBrandingParams): boolean => {
  const initial = pickAll<IBranding | {}, Partial<IBranding>>(comparingProps, initialBranding || {});
  const current = pickAll<IBrandingParams | {}, Partial<IBrandingParams>>(comparingProps, branding || {});
  return equals(initial, current);
};
